<template>
	<Page :info="info"/>
</template>
<script>
import Page from '../common/Page'
export default {
	components:{Page},
	data(){
		return {
			info:{
				banner:{
					img:'/static/images/scheme/banner11.jpg',
					title:'农业行业风险解决方案',
					subtitle:'我们针对于农业行业特性，输出定制如下组合方案， <br>供农业行业基于企业需求进行投保'
				},
				product:[0,1,7,13,14,5],
				case:[0,1,6,10,11]
			}
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/pages/scheme/components/page/Nongye.vue